import { useEffect } from "react";
import { useForm } from "react-hook-form";

import Button from "../../mantine/button/Button";
import Input from "../input/Input";
import styles from "./GoToPageForm.module.scss";

interface GoToPageFormProps {
  totalPages: number;
  currentPage: number;
  onSubmit: (page: number) => void;
  onCancel: () => void;
}

interface FormData {
  pageNumber: string;
}

export const GoToPageForm: React.FC<GoToPageFormProps> = ({
  totalPages,
  currentPage,
  onSubmit,
  onCancel,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      pageNumber: currentPage.toString(),
    },
  });

  useEffect(() => {
    setValue("pageNumber", currentPage.toString());
  }, [currentPage, setValue]);

  const onFormSubmit = (data: FormData) => {
    const pageNumber = parseInt(data.pageNumber, 10);

    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onSubmit(pageNumber);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      onCancel();
    }
  };

  const inputProps = register("pageNumber", {
    required: "Page number is required",
    min: {
      value: 1,
      message: `Page number must be at least 1`,
    },
    max: {
      value: totalPages,
      message: `Page number must be at most ${totalPages}`,
    },
    pattern: {
      value: /^\d+$/,
      message: "Please enter a valid page number",
    },
  });

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className={styles.pageJumpForm}>
      <div className={styles.pageJumpInput}>
        <label htmlFor="page-input" className={styles.pageJumpLabel}>
          Go to page
        </label>
        <div className={styles.pageJumpInputWrapper}>
          <Input
            id="page-input"
            type="number"
            errormessage={errors.pageNumber?.message}
            onKeyDown={handleKeyDown}
            placeholder={`1-${totalPages}`}
            autoFocus
            {...inputProps}
          />
          <Button type="submit" className={styles.goButton}>
            Go
          </Button>
        </div>
      </div>
    </form>
  );
};
